module.exports = __webpack_public_path__ + "img/consultoria_4-3.0331256e.jpg";